import React from 'react';

import './FilterCountBadge.css';

const FilterCountBadge = ({ children }: { children: React.ReactNode }) => (
  <div className="FilterCountBadge">{children}</div>
);

export default FilterCountBadge;
